import React from "react";

const ErrorPage = () => {
  return (
    <div className="min-h-screen flex justify-center items-center">
      <h1 className="text-5xl text-center">
        404 <br />- Page Not Found!
      </h1>
    </div>
  );
};

export default ErrorPage;
